import React from "react";
import { sameOriginMedia } from "@/lib/api";

// Product image with best-effort media protection (disable right-click + drag).
// Not bulletproof, but discourages casual downloading/scraping per V2 requirements.
// src is normalised to the current origin so media always loads on the live domain.
export const ProtectedImage = ({ src, alt = "", className = "", loading = "lazy", ...props }) => (
  <img
    src={sameOriginMedia(src)}
    alt={alt}
    className={className}
    loading={loading}
    decoding="async"
    draggable={false}
    onContextMenu={(e) => e.preventDefault()}
    onDragStart={(e) => e.preventDefault()}
    style={{ WebkitUserSelect: "none", userSelect: "none", WebkitUserDrag: "none" }}
    {...props}
  />
);
